import React from 'react'
import ArrowDown from 'components/CommonUI/svgIcons/ArrowDown'

import Link from 'components/CommonUI/Link/Link'
import { routingConstants } from 'constants/routingConstants'
import DropdownMenu from 'components/CommonUI/Dropdown'

const ControlAdmin = ({ onClick, active, pathname }) => {
  return (
    <button
      className={`admin_tools_button ${
        pathname.includes(routingConstants.panelsManagement) ||
        pathname.includes(routingConstants.devicesManagement) ||
        pathname.includes(routingConstants.devicesConnection) ||
        active
          ? 'active'
          : ''
      }`}
      onClick={onClick}
    >
      <span className="nav_item_text">Admin tools</span>
      <ArrowDown className={active ? 'open' : ''} />
    </button>
  )
}

const AdminToolMenu = ({ pathname }) => {
  return (
    <DropdownMenu
      controlComponent={ControlAdmin}
      controlProps={{ pathname }}
      classNameContainer={'nav_item '}
      withoutLabel
    >
      {/* <DropdownMenu.Item>
        <Link
          className="admin_tool_menu_item"
          to={routingConstants.helpSupport}
        >
          Client management
        </Link>
      </DropdownMenu.Item> */}
      <DropdownMenu.Item>
        <Link
          className="admin_tool_menu_item"
          to={routingConstants.devicesConnection}
        >
          Device connection
        </Link>
      </DropdownMenu.Item>
      <DropdownMenu.Item>
        <Link
          className="admin_tool_menu_item"
          to={routingConstants.devicesManagement}
        >
          Manage devices
        </Link>
      </DropdownMenu.Item>
      <DropdownMenu.Item>
        <Link
          className="admin_tool_menu_item"
          to={routingConstants.panelsManagement}
        >
          Panels management
        </Link>
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}

export default AdminToolMenu
